import { assertIsDefined } from '@gitbook/util-ts';

import { bulkReplace } from './bulkReplace';

const hiraganaMonographs: { [key: string]: string } = {
    あ: 'A',
    い: 'I',
    う: 'U',
    え: 'E',
    お: 'O',
    か: 'KA',
    き: 'KI',
    く: 'KU',
    け: 'KE',
    こ: 'KO',
    さ: 'SA',
    し: 'SHI',
    す: 'SU',
    せ: 'SE',
    そ: 'SO',
    た: 'TA',
    ち: 'CHI',
    つ: 'TSU',
    て: 'TE',
    と: 'TO',
    な: 'NA',
    に: 'NI',
    ぬ: 'NU',
    ね: 'NE',
    の: 'NO',
    は: 'HA',
    ひ: 'HI',
    ふ: 'FU',
    へ: 'HE',
    ほ: 'HO',
    ま: 'MA',
    み: 'MI',
    む: 'MU',
    め: 'ME',
    も: 'MO',
    や: 'YA',
    ゆ: 'YU',
    よ: 'YO',
    ら: 'RA',
    り: 'RI',
    る: 'RU',
    れ: 'RE',
    ろ: 'RO',
    わ: 'WA',
    ゐ: 'WI',
    ゑ: 'WE',
    を: 'WO',
    ん: "N'",
    が: 'GA',
    ぎ: 'GI',
    ぐ: 'GU',
    げ: 'GE',
    ご: 'GO',
    ざ: 'ZA',
    じ: 'JI',
    ず: 'ZU',
    ぜ: 'ZE',
    ぞ: 'ZO',
    だ: 'DA',
    ぢ: 'DJI',
    づ: 'DZU',
    で: 'DE',
    ど: 'DO',
    ば: 'BA',
    び: 'BI',
    ぶ: 'BU',
    べ: 'BE',
    ぼ: 'BO',
    ぱ: 'PA',
    ぴ: 'PI',
    ぷ: 'PU',
    ぺ: 'PE',
    ぽ: 'PO',
};

const hiraganaDigraphs: { [key: string]: string } = {
    きゃ: 'KYA',
    きゅ: 'KYU',
    きょ: 'KYO',
    しゃ: 'SHA',
    しゅ: 'SHU',
    しょ: 'SHO',
    ちゃ: 'CHA',
    ちゅ: 'CHU',
    ちょ: 'CHO',
    にゃ: 'NYA',
    にゅ: 'NYU',
    にょ: 'NYO',
    ひゃ: 'HYA',
    ひゅ: 'HYU',
    ひょ: 'HYO',
    みゃ: 'MYA',
    みゅ: 'MYU',
    みょ: 'MYO',
    りゃ: 'RYA',
    りゅ: 'RYU',
    りょ: 'RYO',
    ぎゃ: 'GYA',
    ぎゅ: 'GYU',
    ぎょ: 'GYO',
    じゃ: 'JA',
    じゅ: 'JU',
    じょ: 'JO',
    びゃ: 'BYA',
    びゅ: 'BYU',
    びょ: 'BYO',
    ぴゃ: 'PYA',
    ぴゅ: 'PYU',
    ぴょ: 'PYO',
};

const katakanaMonographs: { [key: string]: string } = {
    ア: 'A',
    イ: 'I',
    ウ: 'U',
    エ: 'E',
    オ: 'O',
    カ: 'KA',
    キ: 'KI',
    ク: 'KU',
    ケ: 'KE',
    コ: 'KO',
    サ: 'SA',
    シ: 'SHI',
    ス: 'SU',
    セ: 'SE',
    ソ: 'SO',
    タ: 'TA',
    チ: 'CHI',
    ツ: 'TSU',
    テ: 'TE',
    ト: 'TO',
    ナ: 'NA',
    ニ: 'NI',
    ヌ: 'NU',
    ネ: 'NE',
    ノ: 'NO',
    ハ: 'HA',
    ヒ: 'HI',
    フ: 'FU',
    ヘ: 'HE',
    ホ: 'HO',
    マ: 'MA',
    ミ: 'MI',
    ム: 'MU',
    メ: 'ME',
    モ: 'MO',
    ヤ: 'YA',
    ユ: 'YU',
    ヨ: 'YO',
    ラ: 'RA',
    リ: 'RI',
    ル: 'RU',
    レ: 'RE',
    ロ: 'RO',
    ワ: 'WA',
    ヰ: 'WI',
    ヱ: 'WE',
    ヲ: 'WO',
    ン: 'N',
    ガ: 'GA',
    ギ: 'GI',
    グ: 'GU',
    ゲ: 'GE',
    ゴ: 'GO',
    ザ: 'ZA',
    ジ: 'JI',
    ズ: 'ZU',
    ゼ: 'ZE',
    ゾ: 'ZO',
    ダ: 'DA',
    ヂ: 'DJI',
    ヅ: 'DZU',
    デ: 'DE',
    ド: 'DO',
    バ: 'BA',
    ビ: 'BI',
    ブ: 'BU',
    ベ: 'BE',
    ボ: 'BO',
    パ: 'PA',
    ピ: 'PI',
    プ: 'PU',
    ペ: 'PE',
    ポ: 'PO',
};

const katakanaDigraphs: { [key: string]: string } = {
    アー: 'Ā',
    イー: 'Ī',
    ウー: 'Ū',
    エー: 'Ē',
    オー: 'Ō',
    カー: 'KĀ',
    キー: 'KĪ',
    クー: 'KŪ',
    ケー: 'KĒ',
    コー: 'KŌ',
    サー: 'SĀ',
    シー: 'SHĪ',
    スー: 'SŪ',
    セー: 'SĒ',
    ソー: 'SŌ',
    ター: 'TĀ',
    チー: 'CHĪ',
    ツー: 'TSŪ',
    テー: 'TĒ',
    トー: 'TŌ',
    ナー: 'NĀ',
    ニー: 'NĪ',
    ヌー: 'NŪ',
    ネー: 'NĒ',
    ノー: 'NŌ',
    ハー: 'HĀ',
    ヒー: 'HĪ',
    フー: 'FŪ',
    ヘー: 'HĒ',
    ホー: 'HŌ',
    マー: 'MĀ',
    ミー: 'MĪ',
    ムー: 'MŪ',
    メー: 'MĒ',
    モー: 'MŌ',
    ヤー: 'YĀ',
    ユー: 'YŪ',
    ヨー: 'YŌ',
    ラー: 'RĀ',
    リー: 'RĪ',
    ルー: 'RŪ',
    レー: 'RĒ',
    ロー: 'RŌ',
    ワー: 'WĀ',
    ヰー: 'WĪ',
    ヱー: 'WĒ',
    ヲー: 'WŌ',
    ンー: 'N',
    ガー: 'GĀ',
    ギー: 'GĪ',
    グー: 'GŪ',
    ゲー: 'GĒ',
    ゴー: 'GŌ',
    ザー: 'ZĀ',
    ジー: 'JĪ',
    ズー: 'ZŪ',
    ゼー: 'ZĒ',
    ゾー: 'ZŌ',
    ダー: 'DĀ',
    ヂー: 'DJĪ',
    ヅー: 'DZŪ',
    デー: 'DĒ',
    ドー: 'DŌ',
    バー: 'BĀ',
    ビー: 'BĪ',
    ブー: 'BŪ',
    ベー: 'BĒ',
    ボー: 'BŌ',
    パー: 'PĀ',
    ピー: 'PĪ',
    プー: 'PŪ',
    ペー: 'PĒ',
    ポー: 'PŌ',
    キャ: 'KYA',
    キュ: 'KYU',
    キョ: 'KYO',
    シャ: 'SHA',
    シュ: 'SHU',
    ショ: 'SHO',
    チャ: 'CHA',
    チュ: 'CHU',
    チョ: 'CHO',
    ニャ: 'NYA',
    ニュ: 'NYU',
    ニョ: 'NYO',
    ヒャ: 'HYA',
    ヒュ: 'HYU',
    ヒョ: 'HYO',
    ミャ: 'MYA',
    ミュ: 'MYU',
    ミョ: 'MYO',
    リャ: 'RYA',
    リュ: 'RYU',
    リョ: 'RYO',
    ギャ: 'GYA',
    ギュ: 'GYU',
    ギョ: 'GYO',
    ジャ: 'JA',
    ジュ: 'JU',
    ジョ: 'JO',
    ビャ: 'BYA',
    ビュ: 'BYU',
    ビョ: 'BYO',
    ピャ: 'PYA',
    ピュ: 'PYU',
    ピョ: 'PYO',
    クヮ: 'KWA',
    クィ: 'KWI',
    クェ: 'KWE',
    クォ: 'KWO',
    グヮ: 'GWA',
    スィ: 'SI',
    シェ: 'SHE',
    ズィ: 'ZI',
    ジェ: 'JE',
    ティ: 'TI',
    トゥ: 'TU',
    テュ: 'TYU',
    チェ: 'CHE',
    ツァ: 'TSA',
    ツィ: 'TSI',
    ツェ: 'TSE',
    ツォ: 'TSO',
    ディ: 'DI',
    ドゥ: 'DU',
    デュ: 'DYU',
    ホゥ: 'HU',
    ファ: 'FA',
    フィ: 'FI',
    フェ: 'FE',
    フォ: 'FO',
    フュ: 'FYU',
    イィ: 'YI',
    イェ: 'YE',
    ウィ: 'WI',
    ウゥ: 'WU',
    ウェ: 'WE',
    ウォ: 'WO',
    ヴァ: 'VA',
    ヴィ: 'VI',
    ヴ: 'VU',
    ヴェ: 'VE',
    ヴォ: 'VO',
    ヴュ: 'VYU',
};

const katakanaTrigraphs: { [key: string]: string } = {
    キャー: 'KYĀ',
    キュー: 'KYŪ',
    キョー: 'KYŌ',
    シャー: 'SHĀ',
    シュー: 'SHŪ',
    ショー: 'SHŌ',
    チャー: 'CHĀ',
    チュー: 'CHŪ',
    チョー: 'CHŌ',
    ニャー: 'NYĀ',
    ニュー: 'NYŪ',
    ニョー: 'NYŌ',
    ヒャー: 'HYĀ',
    ヒュー: 'HYŪ',
    ヒョー: 'HYŌ',
    ミャー: 'MYĀ',
    ミュー: 'MYŪ',
    ミョー: 'MYŌ',
    リャー: 'RYĀ',
    リュー: 'RYŪ',
    リョー: 'RYŌ',
    ギャー: 'GYĀ',
    ギュー: 'GYŪ',
    ギョー: 'GYŌ',
    ジャー: 'JĀ',
    ジュー: 'JŪ',
    ジョー: 'JŌ',
    ビャー: 'BYĀ',
    ビュー: 'BYŪ',
    ビョー: 'BYŌ',
    ピャー: 'PYĀ',
    ピュー: 'PYŪ',
    ピョー: 'PYŌ',
};

const katakanaHalfwidths: { [key: string]: string } = {
    ｱ: 'ア',
    ｲ: 'イ',
    ｳ: 'ウ',
    ｴ: 'エ',
    ｵ: 'オ',
    ｶ: 'カ',
    ｷ: 'キ',
    ｸ: 'ク',
    ｹ: 'ケ',
    ｺ: 'コ',
    ｻ: 'サ',
    ｼ: 'シ',
    ｽ: 'ス',
    ｾ: 'セ',
    ｿ: 'ソ',
    ﾀ: 'タ',
    ﾁ: 'チ',
    ﾂ: 'ツ',
    ﾃ: 'テ',
    ﾄ: 'ト',
    ﾅ: 'ナ',
    ﾆ: 'ニ',
    ﾇ: 'ヌ',
    ﾈ: 'ネ',
    ﾉ: 'ノ',
    ﾊ: 'ハ',
    ﾋ: 'ヒ',
    ﾌ: 'フ',
    ﾍ: 'ヘ',
    ﾎ: 'ホ',
    ﾏ: 'マ',
    ﾐ: 'ミ',
    ﾑ: 'ム',
    ﾒ: 'メ',
    ﾓ: 'モ',
    ﾔ: 'ヤ',
    ﾕ: 'ユ',
    ﾖ: 'ヨ',
    ﾗ: 'ラ',
    ﾘ: 'リ',
    ﾙ: 'ル',
    ﾚ: 'レ',
    ﾛ: 'ロ',
    ﾜ: 'ワ',
    ｦ: 'ヲ',
    ﾝ: 'ン',
    ｶﾞ: 'ガ',
    ｷﾞ: 'ギ',
    ｸﾞ: 'グ',
    ｹﾞ: 'ゲ',
    ｺﾞ: 'ゴ',
    ｻﾞ: 'ザ',
    ｼﾞ: 'ジ',
    ｽﾞ: 'ズ',
    ｾﾞ: 'ゼ',
    ｿﾞ: 'ゾ',
    ﾀﾞ: 'ダ',
    ﾁﾞ: 'ヂ',
    ﾂﾞ: 'ヅ',
    ﾃﾞ: 'デ',
    ﾄﾞ: 'ド',
    ﾊﾞ: 'バ',
    ﾋﾞ: 'ビ',
    ﾌﾞ: 'ブ',
    ﾍﾞ: 'ベ',
    ﾎﾞ: 'ボ',
    ﾊﾟ: 'パ',
    ﾋﾟ: 'ピ',
    ﾌﾟ: 'プ',
    ﾍﾟ: 'ペ',
    ﾎﾟ: 'ポ',
    ｧ: 'ァ',
    ｨ: 'ィ',
    ｩ: 'ゥ',
    ｪ: 'ェ',
    ｫ: 'ォ',
    ｬ: 'ャ',
    ｭ: 'ュ',
    ｮ: 'ョ',
    ｯ: 'ッ',
    ｰ: 'ー',
};

const katakanaHalfwidthsCombined: { [key: string]: string } = {
    ｶﾞ: 'ガ',
    ｷﾞ: 'ギ',
    ｸﾞ: 'グ',
    ｹﾞ: 'ゲ',
    ｺﾞ: 'ゴ',
    ｻﾞ: 'ザ',
    ｼﾞ: 'ジ',
    ｽﾞ: 'ズ',
    ｾﾞ: 'ゼ',
    ｿﾞ: 'ゾ',
    ﾀﾞ: 'ダ',
    ﾁﾞ: 'ヂ',
    ﾂﾞ: 'ヅ',
    ﾃﾞ: 'デ',
    ﾄﾞ: 'ド',
    ﾊﾞ: 'バ',
    ﾋﾞ: 'ビ',
    ﾌﾞ: 'ブ',
    ﾍﾞ: 'ベ',
    ﾎﾞ: 'ボ',
    ﾊﾟ: 'パ',
    ﾋﾟ: 'ピ',
    ﾌﾟ: 'プ',
    ﾍﾟ: 'ペ',
    ﾎﾟ: 'ポ',
};

const choonpu = 'ー';

const yoonHiragana = 'ぁぃぅぇぉゃゅょゎゕ';
const yoonKatakana = 'ァィゥェォャュョヮヵ';

const sokuonHiragana = 'っ';
const sokuonKatakana = 'ッ';

const sokuons = sokuonKatakana + sokuonHiragana;

const katakanaSplitCombinators = choonpu + yoonKatakana + sokuonKatakana;
const hiraganaSplitCombinators = choonpu + yoonHiragana + sokuonHiragana;

const kanaSplitCombinators = katakanaSplitCombinators + hiraganaSplitCombinators;

// Used to convert old Nihon-Shiki style romaji into the modern Hepburn form.
// Source: http://nayuki.eigenstate.org/page/variations-on-japanese-romanization
const nihonShiki: { [key: string]: string } = {
    SI: 'SHI',
    ZI: 'JI',
    TI: 'CHI',
    DI: 'JI',
    TU: 'TSU',
    DU: 'ZU',
    SHU: 'SHU', // Prevent HU from accidentally converting
    CHU: 'CHU',
    HU: 'FU',
    CYA: 'CHA',
    CYO: 'CHO',
    CYU: 'CHU',
    CHY: 'CH',
    SYA: 'SHA',
    SYU: 'SHU',
    SYO: 'SHO',
    SHY: 'SH',
    ZYA: 'JA',
    ZYU: 'JU',
    ZYO: 'JO',
    TYA: 'CHA',
    TYU: 'CHU',
    TYO: 'CHO',
    DYA: 'JA',
    DYU: 'JU',
    DYO: 'JO',
};

/**
 * Context for Hepburn operations, lazily loaded for performance.
 */
interface HepburnContext {
    hiraganaMap: { [value: string]: string };
    hiraganaRegex: RegExp;
    hiraganaMonographsRegex: RegExp;
    hiraganaDigraphsRegex: RegExp;
    katakanaMap: { [value: string]: string };
    katakanaRegex: RegExp;
    katakanaMonographsRegex: RegExp;
    katakanaDigraphsRegex: RegExp;
    katakanaHalfwidthsCombinedRegex: RegExp;
    katakanaHalfwidthsRegex: RegExp;
    nihonShikiRegex: RegExp;
}

let context: HepburnContext | undefined;

function withHepburnContext(): HepburnContext {
    if (!context) {
        context = initializeHepburnContext();
    }

    return context;
}

function initializeHepburnContext(): HepburnContext {
    // For use with toHiragana
    const hiraganaMap: { [value: string]: string } = {};

    Object.entries(hiraganaMonographs).forEach(([key, value]) => {
        if (!hiraganaMap[value]) {
            hiraganaMap[value] = key;
        }
    });

    Object.entries(hiraganaDigraphs).forEach(([key, value]) => {
        if (!hiraganaMap[value]) {
            hiraganaMap[value] = key;
        }
    });

    const hiraganaRegex = new RegExp(
        Object.keys(hiraganaMap)
            .sort((a, b) => b.length - a.length)
            .join('|'),
        'g'
    );
    const hiraganaMonographsRegex = keysToRegex(hiraganaMonographs);
    const hiraganaDigraphsRegex = keysToRegex(hiraganaDigraphs);

    // For use with toKatakana
    const katakanaMap: { [value: string]: string } = {};

    Object.entries(katakanaMonographs).forEach(([key, value]) => {
        if (!katakanaMap[value]) {
            katakanaMap[value] = key;
        }
    });

    Object.entries(katakanaDigraphs).forEach(([key, value]) => {
        if (!katakanaMap[value]) {
            katakanaMap[value] = key;
        }
    });

    Object.entries(katakanaTrigraphs).forEach(([key, value]) => {
        if (!katakanaMap[value]) {
            katakanaMap[value] = key;
        }
    });

    const katakanaRegex = new RegExp(
        Object.keys(katakanaMap)
            .sort((a, b) => b.length - a.length)
            .join('|'),
        'g'
    );
    const katakanaMonographsRegex = keysToRegex(katakanaMonographs);
    const katakanaDigraphsRegex = keysToRegex(katakanaDigraphs);
    const katakanaHalfwidthsCombinedRegex = keysToRegex(katakanaHalfwidthsCombined);
    const katakanaHalfwidthsRegex = keysToRegex(katakanaHalfwidths);

    const nihonShikiRegex = keysToRegex(nihonShiki);

    return {
        hiraganaMap,
        hiraganaRegex,
        hiraganaMonographsRegex,
        hiraganaDigraphsRegex,
        katakanaMap,
        katakanaRegex,
        katakanaMonographsRegex,
        katakanaDigraphsRegex,
        katakanaHalfwidthsCombinedRegex,
        katakanaHalfwidthsRegex,
        nihonShikiRegex,
    };
}

// API

export function fromKana(str: string): string {
    const ctx = withHepburnContext();

    // Initial transliteration
    str = bulkReplace(str, ctx.katakanaHalfwidthsCombinedRegex, katakanaHalfwidthsCombined);
    str = bulkReplace(str, ctx.katakanaHalfwidthsRegex, katakanaHalfwidths);
    str = bulkReplace(str, ctx.hiraganaDigraphsRegex, hiraganaDigraphs);
    str = bulkReplace(str, ctx.katakanaDigraphsRegex, katakanaDigraphs);
    str = bulkReplace(str, ctx.hiraganaMonographsRegex, hiraganaMonographs);
    str = bulkReplace(str, ctx.katakanaMonographsRegex, katakanaMonographs);

    // Correct use of sokuon
    str = str.replace(/[っッ]C/g, 'TC').replace(/[っッ](.)/g, '$1$1');

    // Correct usage of N' (M' is a common mistake)
    str = str.replace(/[NM]'([^YAEIOU]|$)/g, 'N$1');

    // Correct use of choonpu
    str = str.replace(/Aー/g, 'Ā');
    str = str.replace(/Iー/g, 'Ī');
    str = str.replace(/Uー/g, 'Ū');
    str = str.replace(/Eー/g, 'Ē');
    str = str.replace(/Oー/g, 'Ō');

    return str;
}

export function toHiragana(str: string) {
    const ctx = withHepburnContext();

    // All conversion is done in upper-case
    str = str.toUpperCase();

    // Correct use of sokuon
    str = str.replace(/TC/g, 'っC');
    str = str.replace(/([^AEIOUN])\1/g, 'っ$1');

    // Transliteration
    str = bulkReplace(str, ctx.hiraganaRegex, ctx.hiraganaMap);

    // Fix any remaining N/M usage (that isn't a N' usage)
    str = str.replace(/N|M/g, 'ん');

    return str;
}

export function toKatakana(str: string): string {
    const ctx = withHepburnContext();

    // All conversion is done in upper-case
    str = str.toUpperCase();

    // Correct use of sokuon
    str = str.replace(/TC/g, 'ッC');
    str = str.replace(/([^AEIOUN])\1/g, 'ッ$1');

    // Transliteration
    str = bulkReplace(str, ctx.katakanaRegex, ctx.katakanaMap);

    // Fix any remaining N/M usage (that isn't a N' usage)
    str = str.replace(/N|M/g, 'ン');

    return str;
}

export function cleanRomaji(str: string): string {
    const ctx = withHepburnContext();

    // Follows many of the suggestions from:
    // http://nayuki.eigenstate.org/page/variations-on-japanese-romanization

    // All conversion is done in upper-case
    str = str.toUpperCase();

    // Should be using N instead of M
    str = str.replace(/(\w)M([^AEIOUY]|$)/g, '$1N$2');

    // Convert the NN form into the more common N'
    str = str.replace(/NN/g, "N'");

    // Convert usage of OU into the more common OO
    // Handle cases like Toukyou
    str = str.replace(/OU/g, 'OO');

    // Fix antiquated usage of OH to mean OO
    // (handle ambiguous cases like 'Kohusai' vs. 'Tohkyoh')
    str = str.replace(/OH([^AIEO]|$)/g, 'OO$1');

    // Replace old Nihon-shiki usage with modern Hepburn form
    str = bulkReplace(str, ctx.nihonShikiRegex, nihonShiki);

    return str;
}

export function splitKana(str: string): string[] {
    return str.split('').reduce<string[]>((r, h) => {
        // if current kana is a combinator
        // or previous syllable and current character both aren't kanas
        // then merge with previous syllable if any
        const lastSyllable = r[r.length - 1];
        if (
            lastSyllable &&
            h.trim() &&
            (kanaSplitCombinators.includes(h) ||
                (!containsHiragana(lastSyllable) &&
                    !containsKatakana(lastSyllable) &&
                    !containsHiragana(h) &&
                    !containsKatakana(h)))
        ) {
            r[r.length - 1] += h;
        } else {
            r.push(h);
        }

        return r;
    }, []);
}

// known issue: unclean romaji might get too chopped up
// e.g. "CHYA" becomes ["C", "HYA"]
export function splitRomaji(str: string): string[] {
    return splitKana(toKatakana(str)).map((k, i, ks) => {
        // if syllable's last character is a sokuon
        // add the first letter of the following syllable if any
        // to the end of current syllable
        const lastSyllable = k.slice(-1)[0];
        if (i < ks.length - 1 && lastSyllable && sokuons.includes(lastSyllable)) {
            const next = ks[i + 1];
            assertIsDefined(next);
            const nextRomaji =
                containsHiragana(next) || containsKatakana(next) ? fromKana(next) : next;

            let nextLetter = nextRomaji[0];

            // correct CC/TC use of sokuon
            if (nextLetter === 'C') {
                nextLetter = 'T';
            }

            const r = fromKana(k.slice(0, -1)) + nextLetter;

            return r;
        }

        return fromKana(k);
    });
}

export function containsHiragana(str: string): boolean {
    const ctx = withHepburnContext();

    // reset regex
    ctx.hiraganaMonographsRegex.lastIndex = 0;
    return ctx.hiraganaMonographsRegex.test(str);
}

export function containsKatakana(str: string): boolean {
    const ctx = withHepburnContext();

    // reset regex
    ctx.katakanaMonographsRegex.lastIndex = 0;
    ctx.katakanaHalfwidthsRegex.lastIndex = 0;
    return ctx.katakanaMonographsRegex.test(str) || ctx.katakanaHalfwidthsRegex.test(str);
}

export function containsKana(str: string): boolean {
    return containsHiragana(str) || containsKatakana(str);
}

export function containsKanji(str: string): boolean {
    return /[\u4e00-\u9fcf\uf900-\ufaff\u3400-\u4dbf]/.test(str);
}

function keysToRegex(obj: { [key: string]: string }): RegExp {
    return new RegExp(Object.keys(obj).join('|'), 'g');
}
